var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3645_703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.576 8.47124C13.701 8.34622 13.7712 8.17668 13.7712 7.9999C13.7712 7.82313 13.701 7.65359 13.576 7.52857L9.80467 3.75724C9.74317 3.69356 9.66961 3.64277 9.58827 3.60784C9.50694 3.5729 9.41946 3.55451 9.33094 3.55374C9.24242 3.55297 9.15463 3.56983 9.0727 3.60336C8.99077 3.63688 8.91634 3.68638 8.85374 3.74897C8.79115 3.81157 8.74164 3.886 8.70812 3.96793C8.6746 4.04986 8.65773 4.13765 8.6585 4.22617C8.65927 4.31469 8.67766 4.40217 8.7126 4.48351C8.74754 4.56484 8.79833 4.63841 8.862 4.6999L11.4953 7.33324H2.66667C2.48986 7.33324 2.32029 7.40347 2.19526 7.5285C2.07024 7.65352 2 7.82309 2 7.9999C2 8.17671 2.07024 8.34628 2.19526 8.47131C2.32029 8.59633 2.48986 8.66657 2.66667 8.66657H11.4953L8.862 11.2999C8.74056 11.4256 8.67337 11.594 8.67489 11.7688C8.67641 11.9436 8.74652 12.1108 8.87012 12.2344C8.99373 12.3581 9.16094 12.4282 9.33574 12.4297C9.51053 12.4312 9.67894 12.364 9.80467 12.2426L13.576 8.47124Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3645_703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(0 1 -1 0 16 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.abb0ab45acea165a84db35ebd9c47c7f.svg";
export { ForwardRef as ReactComponent };